// extracted by mini-css-extract-plugin
export default {"button":"ButtonKey_button__nruqW"};